import { render, staticRenderFns } from "./CourseOrder.vue?vue&type=template&id=6b95e7d4&"
import script from "./CourseOrder.vue?vue&type=script&lang=js&"
export * from "./CourseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports